"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ColorExceptions_1 = require("./ColorExceptions");
const Array_1 = require("@pups/utility/build/Array");
const Number_1 = require("@pups/utility/build/Number");
/**
 * Classe statica.
 * Si utilizza il metodo 'parse' per convertire una string o un oggetto in un oggetto del tipo Types.Color.Parsing.Match
 *
 * @class ColorParser
 */
class ColorParser {
    /**
     *
     *
     * @static
     * @param {Types.Color.All} color
     * @returns {Types.Color.Parsing.Match}
     * @memberof ColorParser
     */
    static parse(color) {
        return typeof color === 'string' ? ColorParser.fromString(color) : ColorParser.fromObject(color);
    }
    /**
     *
     *
     * @private
     * @static
     * @param {string} color
     * @returns {Types.Color.Parsing.Match}
     * @memberof ColorParser
     */
    static fromString(color) {
        let match, result = null;
        for (let i = ColorParser.MATCHES.length - 1; i >= 0; i--)
            if ((match = ColorParser.MATCHES[i].regexp.exec(color)))
                result = { type: ColorParser.MATCHES[i].type, value: match.slice(1) };
        if (!result)
            throw new ColorExceptions_1.ColorNotValidException(color, ColorParser.MATCHES);
        if (result.type.indexOf('hex') != -1)
            return result;
        else
            result.value = Array_1.toFloat(result.value);
        const matchResolver = typeof ColorParser.MATCH_VALUES[result.type] === 'string' ? ColorParser.MATCH_VALUES[ColorParser.MATCH_VALUES[result.type]] : ColorParser.MATCH_VALUES[result.type];
        for (let i in matchResolver.possibilities) {
            if (ColorParser.isFromZeroTo(result.value, matchResolver.possibilities[i])) {
                if (matchResolver.possibilities[i] != matchResolver.want) {
                    result.value = ColorParser.scaleToFromZeroTo(result.value, matchResolver.possibilities[i], matchResolver.want);
                }
                return result;
            }
        }
        throw new ColorExceptions_1.ColorParsingException(color);
    }
    /**
     *
     *
     * @private
     * @static
     * @param {(Types.Color.RGB | Types.Color.HSV | Types.Color.HSL | Types.Color.CMYK)} color
     * @returns {Types.Color.Parsing.Match}
     * @memberof ColorParser
     */
    static fromObject(color) {
        if ('r' in color)
            return { type: 'rgba', value: [color.r, color.g, color.b, color.a] };
        if ('l' in color)
            return { type: 'hsla', value: [color.h, color.s, color.l, color.a] };
        if ('v' in color)
            return { type: 'hsva', value: [color.h, color.s, color.v, color.a] };
        if ('c' in color)
            return { type: 'cmyk', value: [color.c, color.m, color.y, color.k] };
        throw new ColorExceptions_1.ColorParsingException(JSON.stringify(color));
    }
    /**
     *
     *
     * @static
     * @param {(Array<string | number>)} values
     * @returns {boolean}
     * @memberof ColorParser
     */
    static isFromZeroToOne(values) {
        for (let i in values)
            if (values[i] > 1)
                return false;
        return true;
    }
    /**
     *
     *
     * @static
     * @param {(Array<string | number>)} values
     * @param {(Array<number> | number)} maxValues
     * @returns {boolean}
     * @memberof ColorParser
     */
    static isFromZeroTo(values, maxValues) {
        if (((Array.isArray(maxValues) && maxValues != ColorParser.ZERO_TO_ONE) || (!Array.isArray(maxValues) && maxValues == 1)) && ColorParser.isFromZeroToOne(values))
            return false;
        for (let i in values)
            if (values[i] > (Array.isArray(maxValues) ? maxValues[i] : maxValues))
                return false;
        return true;
    }
    /**
     *
     *
     * @static
     * @param {Array<number>} values
     * @param {(Array<number> | number)} maxValues
     * @returns {Array<number>}
     * @memberof ColorParser
     */
    static scaleToFromZeroToOne(values, maxValues) {
        if (ColorParser.isFromZeroToOne(values))
            return values;
        const result = [];
        for (let i in values)
            result.push(Number_1.clamp01(values[i] / (Array.isArray(maxValues) ? maxValues[i] : maxValues)));
        return result;
    }
    /**
     *
     *
     * @static
     * @param {Array<number>} values
     * @param {Array<number>} maxValues
     * @param {Array<number>} wantValues
     * @returns
     * @memberof ColorParser
     */
    static scaleToFromZeroTo(values, maxValues, wantValues) {
        const result = [];
        for (let i in values)
            result.push(Number_1.clamp(0, (Array.isArray(wantValues) ? wantValues[i] : wantValues), values[i] / (Array.isArray(maxValues) ? maxValues[i] : maxValues) * (Array.isArray(wantValues) ? wantValues[i] : wantValues)));
        return result;
    }
}
/**
 *
 *
 * @private
 * @static
 * @memberof ColorParser
 */
ColorParser.CSS_INTEGER = '[-\\+]?\\d+%?';
/**
 *
 *
 * @private
 * @static
 * @memberof ColorParser
 */
ColorParser.CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
/**
 *
 *
 * @private
 * @static
 * @memberof ColorParser
 */
ColorParser.CSS_UNIT = '(?:' + ColorParser.CSS_NUMBER + ')|(?:' + ColorParser.CSS_INTEGER + ')';
/**
 *
 *
 * @private
 * @static
 * @memberof ColorParser
 */
ColorParser.PERMISSIVE_MATCH3 = '[\\s|\\(]+(' + ColorParser.CSS_UNIT + ')[,|\\s]+(' + ColorParser.CSS_UNIT + ')[,|\\s]+(' + ColorParser.CSS_UNIT + ')\\s*\\)?';
/**
 *
 *
 * @private
 * @static
 * @memberof ColorParser
 */
ColorParser.PERMISSIVE_MATCH4 = '[\\s|\\(]+(' + ColorParser.CSS_UNIT + ')[,|\\s]+(' + ColorParser.CSS_UNIT + ')[,|\\s]+(' + ColorParser.CSS_UNIT + ')[,|\\s]+(' + ColorParser.CSS_UNIT + ')\\s*\\)?';
/**
 *
 *
 * @private
 * @static
 * @type {Array<number>}
 * @memberof ColorParser
 */
ColorParser.ZERO_TO_ONE = [1, 1, 1, 1];
/**
 *
 *
 * @private
 * @static
 * @type {Array<number>}
 * @memberof ColorParser
 */
ColorParser.ZERO_TO_255 = [255, 255, 255, 1];
/**
 *
 *
 * @private
 * @static
 * @memberof ColorParser
 */
ColorParser.MATCH_VALUES = {
    'rgb': {
        possibilities: [ColorParser.ZERO_TO_ONE, ColorParser.ZERO_TO_255],
        want: ColorParser.ZERO_TO_255
    },
    'rgba': 'rgb',
    'cmyk': {
        possibilities: [[100, 100, 100, 100], ColorParser.ZERO_TO_ONE],
        want: ColorParser.ZERO_TO_ONE
    },
    'hsl': {
        possibilities: [[360, 100, 100, 1], ColorParser.ZERO_TO_ONE],
        want: ColorParser.ZERO_TO_ONE
    },
    'hsla': 'hsl', 'hsv': 'hsl', 'hsva': 'hsl'
};
/**
 *
 *
 * @private
 * @static
 * @type {Array<Types.Color.Parsing.Regex>}
 * @memberof ColorParser
 */
ColorParser.MATCHES = [
    //{ type: 'CSS_UNIT', regexp: new RegExp(CSS_UNIT) },
    { type: 'rgb', regexp: new RegExp('rgb' + ColorParser.PERMISSIVE_MATCH3) },
    { type: 'rgba', regexp: new RegExp('rgba' + ColorParser.PERMISSIVE_MATCH4) },
    { type: 'hsl', regexp: new RegExp('hsl' + ColorParser.PERMISSIVE_MATCH3) },
    { type: 'hsla', regexp: new RegExp('hsla' + ColorParser.PERMISSIVE_MATCH4) },
    { type: 'hsv', regexp: new RegExp('hsv' + ColorParser.PERMISSIVE_MATCH3) },
    { type: 'hsva', regexp: new RegExp('hsva' + ColorParser.PERMISSIVE_MATCH4) },
    { type: 'cmyk', regexp: new RegExp('cmyk' + ColorParser.PERMISSIVE_MATCH4) },
    { type: 'hex3', regexp: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/ },
    { type: 'hex6', regexp: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ },
    { type: 'hex4', regexp: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/ },
    { type: 'hex8', regexp: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ },
];
exports.default = ColorParser;
//# sourceMappingURL=ColorParser.js.map